import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M20.0001 0.833984C32.7819 0.833984 39.1637 7.21576 39.1637 19.9976C39.1637 32.7794 32.7819 39.1612 20.0001 39.1612C7.21825 39.1612 0.836426 32.7794 0.836426 19.9976C0.836426 7.21576 7.21825 0.833984 20.0001 0.833984Z",
      fill: "#FF5537"
    }, null, -1),
    _createElementVNode("path", {
      d: "M20 40.0712C6.6727 40.0712 -0.0727539 33.3257 -0.0727539 19.9985C-0.0727539 6.6712 6.6727 -0.0742188 20 -0.0742188C33.3272 -0.0742188 40.0727 6.6712 40.0727 19.9985C40.0727 33.3257 33.3272 40.0712 20 40.0712ZM20 1.74396C7.70907 1.74396 1.74543 7.72574 1.74543 19.9985C1.74543 32.2712 7.72725 38.253 20 38.253C32.2727 38.253 38.2545 32.2712 38.2545 19.9985C38.2545 7.72574 32.2727 1.74396 20 1.74396Z",
      fill: "#FF5537"
    }, null, -1),
    _createElementVNode("path", {
      d: "M8.34545 27.7434C8.34545 20.107 13.4182 11.8161 23.2 10.2161C23.2 10.2161 26.1273 9.68885 27.5454 10.2525C28.0727 10.4161 28.8 11.0343 28.9273 11.7979C29.2545 13.0888 28.0364 14.1798 27.9636 14.2343C28.0364 14.2707 29.0727 14.6343 29.2727 15.5979C29.4545 16.4525 28.8727 17.1434 27.8182 17.507C29.5454 19.0888 29.1818 22.2524 27.5636 23.7252C29.8909 23.9797 31.6545 25.4888 31.6545 27.7434C31.6545 29.3434 27.7636 29.9979 19.9818 29.9979C12.2 29.9979 8.30908 29.3616 8.30908 27.7434H8.34545Z",
      fill: "#FFD8D1"
    }, null, -1)
  ]))]))
}
export default { render: render }